/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Sean Larkin @thelarkinn
*/
"use strict";

var SizeFormatHelpers = exports;

SizeFormatHelpers.formatSize = function (size) {
  if (typeof size !== "number" || Number.isNaN(size) === true) {
    return "unknown size";
  }

  if (size <= 0) {
    return "0 bytes";
  }

  var abbreviations = ["bytes", "KiB", "MiB", "GiB"];
  var index = Math.floor(Math.log(size) / Math.log(1024));
  return "".concat(+(size / Math.pow(1024, index)).toPrecision(3), " ").concat(abbreviations[index]);
};